import React from 'react';

import { Accordion } from '../../components/Accordion/Accordion';
import { useInView } from '../../hooks/useInView';
import type { Faq } from './types';

import './FaqSection.css';

type FaqSectionProps = {
    data: Faq;
};

export function FaqSection({ data }: FaqSectionProps) {
    const [ref, inView] = useInView<HTMLElement>();

    return (
        <section
            ref={ref}
            className={`programs-faq faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <div className="programs-faq__head">
                <span className="programs-eyebrow faves-reveal">{data.eyebrow}</span>
                <h2
                    className="programs-faq__heading faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h2>
            </div>
            <Accordion
                items={data.items}
                classPrefix="programs-faq"
                idPrefix="programs-faq"
                initialExpandedIndex={0}
                answerClass=""
            />
        </section>
    );
}
